import { Icon } from '@/src/tools/icon';
import React from 'react';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import ColorPicker from 'src/components/Modules-revamp/ColorPicker';
import { Field } from 'src/components/RcForm';
import Slider from 'src/components/Slider/MarginSlider';
import { useI18n } from 'src/hooks/useRouterChange';
import { sectionProps } from 'src/tools/constant';
import {
  activeTabColor,
  gapUnderTab,
  regularTabColor,
  tabStyle,
} from 'src/tools/contentModulesFieldName';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';
const TabStyle = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <Section {...sectionProps}>
      <Field name={[tabStyle, gapUnderTab]}>
        <Slider
          min={0}
          max={240}
          disabled={props.sliderDisabled}
          customIcon={
            <Icon
              type='icona-verticalgap'
              className={css.icon}
              onClick={(e) => e.stopPropagation()}
            />
          }
          title={getI18n('general.gapUnderTab')}
        />
      </Field>
      <ItemWrapper title={getI18n('general.regularTabColour')} size='small'>
        <Field name={[tabStyle, regularTabColor]}>
          <ColorPicker disabled={props.disabled} />
        </Field>
      </ItemWrapper>
      <ItemWrapper title={getI18n('general.activeTabColour')} size='small'>
        <Field name={[tabStyle, activeTabColor]}>
          <ColorPicker disabled={props.disabled} />
        </Field>
      </ItemWrapper>
    </Section>
  );
};
export default TabStyle;
